import React from "react";
import { greatStaircaseRelayStory } from "../../story/greatStaircaseRelayStory";
import { StoryPlayer } from "./components/StoryPlayer";
import "./ForestRescueEbook.css";
import "./GreatStaircaseRelayEbook.css";

export function GreatStaircaseRelayEbook() {
  return (
    <div className="ebook-app ebook-book">
      <StoryPlayer story={greatStaircaseRelayStory} />
    </div>
  );
}
